$(document).ready(function () {
  //Get product gift
  const giftProductIdArray = [];
  const elListGiftBox = $('.list-gift-box');
  const giftVersion = '4';
  var giftAttributeOptions = [];

  // The html code of the add gift wrapping button
  function getGiftBoxButtonHtml() {
    return `
        <div class="Cart__NoteContainer cart__item-row">
          <div class="cart-attribute-gift-box" style="width:100%;text-align:right;">
            <button type="button" class="btn btn-primary btn-block" id="add-gift-box">ラッピングを追加</button>
          </div>
        </div>
    `;
  }

  function getHrHtml() {
    return `<hr style="margin: 0px 0px 10px 0px;border: 1px solid #e8e8e1">`;
  }

  // get product list in cart
  function getProductInCart() {
    var cart_items = [];
    $('.cart-item-product-data').each(function () {
      let dataId = $(this).data('id').split(':')[0];
      let isProductGift = giftProductIdArray.includes(dataId);

      cart_items.push({
        'id': $(this).data('id'),
        'max_quantity': $(this).data('quantity'),
        'name': $(this).data('title'),
        'quantity': '',
        'wrapping': $(this).data('wrapping'),
        'attribute_product': cart_items.length,
        'disabled': 1,
        'sku': $(this).data('sku'),
        'is_product_gift': isProductGift
      });
    });

    return cart_items;
  }

  // get gift items
  function getGiftItems() {
    var gift = localStorage.getItem('gift');
    var product_in_cart = getProductInCart();

    if (product_in_cart.length == 0) {
      localStorage.removeItem('gift');
      return [];
    }
    if (gift == null) {
      // init gift
      return [{
        index: 1,
        title: 'ギフトラッピング：1つめ',
        attribute: {
          index: 1,
          name: 'attributes[Gift01]',
          name_product: 'attributes[GiftProduct01]',
          value: giftAttributeOptions,
          selected: '',
          giftOptionAtrribute: {}
        },
        product: product_in_cart,
        gift_product: '',
        gift_product_id: giftProductIdArray,
        wrapping_tags: []
      }];
    }
    gift = JSON.parse(gift);
    // check product in cart, add product to gift
    for (let i in product_in_cart) {
      var found = false;
      for (let j in gift) {
        for (let k in gift[j].product) {
          if (product_in_cart[i].id == gift[j].product[k].id) {
            found = true;
            break;
          }
        }
        if (found) {
          break;
        }
      }
      if (!found) {
        for (let j in gift) {
          gift[j].product.unshift(product_in_cart[i]);
        }
      }
    }
    // check product in gift, remove product not in cart
    for (let i in gift) {
      for (let j in gift[i].product) {
        var found = false;
        for (let k in product_in_cart) {
          if (product_in_cart[k].id == gift[i].product[j].id) {
            found = true;
            break;
          }
        }
        if (!found) {
          gift[i].product.splice(j, 1);
        }
      }

      // Update value for gift list
      gift[i].attribute.value = giftAttributeOptions;
    }
    return gift;
  }

  function checkGiftVersion() {
    let gift = localStorage.getItem('gift');
    let version = localStorage.getItem('giftVersion');

    if (giftVersion != version || !gift) {
      localStorage.removeItem('gift');
      localStorage.setItem('giftVersion', giftVersion);

      // Generate html for gift wrapping
      $('.list-gift-box').html(getHrHtml() + buildGiftHtml());

      // Check the number of products in the gift package is valid or not
      changeMaxQuantityGiftProducts();

      return false;
    }
    checktGiftProducIncart();
    checkGiftEmpty();


    // Generate html for gift wrapping
    $('.list-gift-box').html(getHrHtml() + buildGiftHtml());

    // Check the number of products in the gift package is valid or not
    changeMaxQuantityGiftProducts();

    if (getGiftItems().length < giftOptions.limit) {
      $('.button-gift-box').html(getHrHtml() + getGiftBoxButtonHtml());
    }
  }

  // Generate html code to be able to choose gift wrapping
  function buildGiftAttributeHtml(gift_attribute, selected) {
    var html = '';
    var selected_attibute = '';
    for (let i in gift_attribute) {
      selected_attibute = '';
      if (gift_attribute[i].value == selected) {
        selected_attibute = 'selected';
      }
      html += `<option value="${gift_attribute[i].value}" ${selected_attibute} data-id="${gift_attribute[i].id}">${gift_attribute[i].content}</option>`;
    }
    return html;
  }

  // Generate html code for products in gift wrapping
  function buildGiftProductHtml(giftItem, attribute, giftProductIndex = '') {
    let gift_product = giftItem.product;
    let giftAttrName = giftItem.attribute.name;
    let wrappingTags = giftItem.wrapping_tags;
    var html = '';

    for (let i in gift_product) {
      let hide_product = '';
      let disable_product = '';

      if (gift_product[i].wrapping == '__wrapping:no' || gift_product[i].is_product_gift == true) {
        hide_product = 'style="display:none"';
      } else if (wrappingTags != '' && wrappingTags.includes(gift_product[i].wrapping) == false) {
        hide_product = 'style="display:none"';
      }

      if (gift_product[i].disabled) {
        disable_product = 'disabled';
      }

      if (giftAttrName.includes('GiftNoshiCategory') || giftAttrName.includes('GiftNoshiName')) {
        setAttrNameQuantity = `${giftAttrName}-${gift_product[i].attribute_product}`;
        setAttrNameProduct = `${giftAttrName}-product${gift_product[i].attribute_product}`;
      }

      html += `
        <tr ${hide_product}>
          <td style="width: 70%;">
          ${gift_product[i].name}
          </td>
          <td style="width: 20%;vertical-align: middle;">
          <input type="hidden" name="ProductName${attribute.index}-product${gift_product[i].attribute_product}" value="${$.trim(gift_product[i].name)}" ${disable_product}>
          <input type="text" name="GiftProduct${attribute.index}-${gift_product[i].attribute_product}" value="${gift_product[i].quantity}" class="gift-product-quantity" data-index="${giftProductIndex}" data-id="${gift_product[i].id}" data-quantity= "${gift_product[i].quantity}" autocomplete="off" style="width:100%;padding:0;text-align:center">
          </td>
          <td style="width: 10%;vertical-align: middle;">
          個
          </td>
        </tr> 
      `;
    }
    return html;
  }

  // Generate html code for each gift package
  function buildGiftItemHtml(gift_item) {
    let hide_product = '';
    let hrHtml = gift_item.index == 1 ? '' : getHrHtml();
    let option = '';
    let blockAttribute ='';

    if (gift_item.attribute.selected == '') {
      hide_product = 'display:none';
    }

    for (let giftOptions of gift_item.attribute.value) {
      let giftEmpty = gift_item.product.every(product => product.quantity === '');

      if (giftOptions.value == gift_item.attribute.selected) {
        blockAttribute = giftOptions.blockAttribute;

        if (giftOptions.dataOption) {
          for (let options of giftOptions.dataOption) {
            option += `<select name="${options.name}" class="gift-option" data-gift-empty="${giftEmpty}" style="width:100%; margin-top: 10px;">"`;
            option += `<option value="" selected>選択してください</option>`;

            for (let opiton of options.opiton) {
              let selected = '';

              if (gift_item.attribute.giftOptionAtrribute[options.name] && opiton == gift_item.attribute.giftOptionAtrribute[options.name]) {
                selected = 'selected';
              }

              option += `<option value="${opiton}" ${selected}>${opiton}</option>`;
            }
            option += `</select>`;
          }
        }
      }
    }

    if (typeof blockAttribute == 'object'){
      blockAttribute = `data-shopify-editor-block=\"{&quot;id&quot;:&quot;${blockAttribute.id}&quot;,&quot;type&quot;:&quot;${blockAttribute.type}&quot;}\"`;
    }

    return `
      ${hrHtml}
      <div class="Cart__NoteContainer cart__item-row" style="flex-direction:column;" data-index="${gift_item.index}">
        <div class="cart-attribute-gift-box" style="width:100%;" ${blockAttribute}>
          <label for="gift-box"><span>${gift_item.title}</span></label>
          <select name="${gift_item.attribute.name}" class="gift-box-attribute product-gift-index-${gift_item.index}" style="width:100%"/>
            ${buildGiftAttributeHtml(gift_item.attribute.value, gift_item.attribute.selected)}
          </select>
          ${option}
        </div>
        <div class="cart-attribute-gift-box-product" style="width:100%;margin-top:10px;${hide_product}">
          <label for="gift-box"><span>このギフトに含める商品</span></label>
          <div class="gift-box-product" style="background: #fff;">
            <table>
              ${buildGiftProductHtml(gift_item, gift_item.attribute, gift_item.index)}
            </table>
          </div>
        </div>
      </div>
    `;
  }

  // Generate gift wrapping html code
  function buildGiftHtml() {
    var gift_items = getGiftItems();
    var html = '';

    for (let i in gift_items) {
      let selected = false;

      for (let giftproduct of gift_items[i].attribute.value) {
        if (giftproduct.value == gift_items[i].attribute.selected) {
          selected = true;
          break;
        }
      }

      if (!selected) {
        gift_items[i].attribute.selected = '';

        for (let product of gift_items[i].product) {
          product.quantity = '';
        }
      }

      html += buildGiftItemHtml(gift_items[i]);
    }

    localStorage.setItem('gift', JSON.stringify(gift_items));

    return html;
  }

  // add new gift item
  function addNewGiftItem() {
    var gift_items = getGiftItems();
    var product_in_cart = getProductInCart();

    var gift_item = {
      index: gift_items.length + 1,
      title: 'ギフトラッピング:' + (gift_items.length + 1) + 'つめ',
      attribute: {
        index: gift_items.length + 1,
        name: 'attributes[Gift0' + (gift_items.length + 1) + ']',
        name_product: 'attributes[GiftProduct0' + (gift_items.length + 1) + ']',
        value: giftAttributeOptions,
        selected: '',
        selected_id: '',
      },
      wrapping_tags: [],
      product: product_in_cart,
      gift_product_id: giftProductIdArray
    };
    gift_items.push(gift_item);
    localStorage.setItem('gift', JSON.stringify(gift_items));
    return gift_item;
  }

  // The function checks whether the quantity entered in the quantity field of the products in the gifts is valid or not.
  function checkGiftProductQuantity(product_id, quantity, current_index_gift) {
    var product_in_cart = getProductInCart();
    var gift_items = getGiftItems();
    let total_quantity = 0;

    if (isNaN(parseInt(quantity))) {
      quantity = 0;
    }
    for (let i in gift_items) {
      if (gift_items[i].index != current_index_gift) {
        for (let j in gift_items[i].product) {
          if (gift_items[i].product[j].id == product_id) {
            if (gift_items[i].product[j].quantity == '') {
              gift_items[i].product[j].quantity = 0;
            }
            total_quantity += parseInt(gift_items[i].product[j].quantity);
          }
        }
      }
    }
    for (let i in product_in_cart) {
      if (product_in_cart[i].id == product_id) {
        if (total_quantity + parseInt(quantity) <= parseInt(product_in_cart[i].max_quantity)) {
          return true;
        }
      }
    }
    return false;
  }

  // Set the maximum number of products of gifts.
  function setMaxQuanityGiftProduct(id, new_quantity) {
    var gift_items = getGiftItems();
    for (let i in gift_items) {
      for (let j in gift_items[i].product) {
        if (gift_items[i].product[j].id == id) {
          if (parseInt(gift_items[i].product[j].max_quantity) > parseInt(new_quantity)) {
            gift_items[i].product[j].quantity = '';
          }
          gift_items[i].product[j].max_quantity = new_quantity;
        }
      }
    }
    localStorage.setItem('gift', JSON.stringify(gift_items));
    $('.list-gift-box').html(getHrHtml() + buildGiftHtml());
    return gift_items;
  }

  // Change the maximum number of products of gifts when the number of products in the cart is changed.
  function changeMaxQuantityGiftProduct(_this) {
    let oldQuantity = _this.parent().children('.js-qty__num').val();
    let id = _this.parent().children('.js-qty__num').data('id');
    let totalSeconds = 0;

    let setinterValObj = setInterval(function () {
      let isLoading = $('.js-qty__wrapper.is-loading').hasClass('is-loading');
      totalSeconds += 800;

      if (!isLoading) {
        clearInterval(setinterValObj);

        let newQuantity = $(document).find('.js-qty__num[data-id="' + id + '"]').val();
        checktGiftProducIncart();
        setMaxQuanityGiftProduct(id, newQuantity);
      }

      if (totalSeconds >= 8000) {
        clearInterval(setinterValObj);

        checktGiftProducIncart();
        setMaxQuanityGiftProduct(id, oldQuantity);
      }
    }, 500);
  }

  // Change the maximum number of products of gifts when the number of products in the cart is changed.
  function changeMaxQuantityGiftProducts() {
    $('.js-qty__num').each(function () {
      changeMaxQuantityGiftProduct($(this));
    });
  }

  // Add gift product
  function addGiftProduct(dataGiftProduct = '') {
    var dataGiftProductClone = structuredClone(dataGiftProduct);
    var itemProudct = [];
    dataGiftProductClone = dataGiftProductClone.reverse();

    for (let i in dataGiftProductClone) {
      if (dataGiftProductClone[i].id && dataGiftProductClone[i].id != 'undefined') {
        itemProudct.push({
          id: dataGiftProductClone[i].id,
          quantity: dataGiftProductClone[i].quantity,
          properties: {
            '_SKU': dataGiftProductClone[i].sku
          }
        });

        if (dataGiftProductClone[i].attribute) {
          for (const [key, value] of Object.entries(dataGiftProductClone[i].attribute)) {
            itemProudct[i].properties[key] = value;
          }
        }

        itemProudct[i].properties['このギフトに含める商品'] = dataGiftProductClone[i].nameProductInGift;
        itemProudct[i].properties['_gift'] = dataGiftProductClone[i].index;
      }
    }

    if (!itemProudct || itemProudct.length == 0) {
      document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
      elListGiftBox.removeClass('is-loading');
      return false;
    }

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        items: itemProudct
      },
      dataType: 'json',
      success: function (data) {
        setGiftProductKey(data);
        document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
        elListGiftBox.removeClass('is-loading');
      },
      error: function (error) {
        //  console.log('error: ', error);
      }
    });
  }

  // Remove product gift from cart
  function removeGiftProduct(dataGiftProduct = '') {
    let gift = JSON.parse(localStorage.getItem('gift'));
    let updates = {};

    for (const item of gift) {
      for (const product of item.product) {
        if (product.is_product_gift == true) {
          let productKey = product.id;
          updates[productKey] = 0;
        }
      }
    }

    elListGiftBox.addClass('is-loading');

    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      dataType: 'json',
      data: {
        updates
      },
      success: function () {
        if (dataGiftProduct) {
          addGiftProduct(dataGiftProduct);
        } else {
          elListGiftBox.removeClass('is-loading');
        }
      },
      error: function (data) {
        //console.log('error', data);
      }
    });
  }

  function updateGiftProduct() {
    const giftItems = getGiftItems();
    const dataGiftProduct = [];

    for (const item of giftItems) {
      var nameProductInGift = '';
      var giftIsEmpty = true;
      let sku = '';

      for (let i = 0; i < item.product.length; i++) {
        if (item.product[i].quantity !== '') {
          nameProductInGift += `${item.product[i].name}: ${item.product[i].quantity}個 | `;
          sku += `${item.product[i].sku}: ${item.product[i].quantity}個 | `;
          giftIsEmpty = false;
        }
      }

      nameProductInGift = nameProductInGift.slice(0, -3);
      sku = sku.slice(0, -3);
      giftProductIdList = item.gift_product_id;
      const giftProductId = item.gift_product;

      if (giftProductId && giftProductId != 'undefined' && !giftIsEmpty) {
        dataGiftProduct.push({
          id: giftProductId,
          quantity: 1,
          nameProductInGift: nameProductInGift,
          index: item.index,
          sku: sku,
          attribute: item.attribute.giftOptionAtrribute
        });
      }
    }

    removeGiftProduct(dataGiftProduct);
  }

  function checkInputVal(_this) {
    let accepted = true;
    let indexGift = _this.parents('.Cart__NoteContainer.cart__item-row').data('index');
    let productId = _this.data('id');
    let quantity = _this.val();

    quantity = Number(quantity.replace(/[０-９]/g, (ch) => String.fromCharCode(ch.charCodeAt(0) - 65248)));

    if (quantity != '' && isNaN(parseInt(quantity))) {
      _this.val(_this.data('quantity'));
      accepted = false;
    } else {
      if (parseInt(quantity) < 0) {
        _this.val(_this.data('quantity'));
        accepted = false;
      } else if (quantity != '') {
        _this.val(parseInt(quantity));
      }
    }

    if (checkGiftProductQuantity(productId, quantity, indexGift) == false) {
      _this.val(_this.data('quantity'));
      accepted = false;
    }

    return accepted ? quantity : 'false';
  }

  // Set key product gift
  function setGiftProductKey(data) {
    let gift = JSON.parse(localStorage.getItem('gift'));

    for (let i = 0; i < data.items.length; i++) {
      for (let j = 0; j < gift.length; j++) {
        if (data.items[i].properties._gift == gift[j].index) {
          gift[j].giftKey = data.items[i].key;
          break;
        }
      }
    }

    localStorage.setItem('gift', JSON.stringify(gift));
  }

  // Delete the gift wrap if the gift wrap is not in the cart.
  function checktGiftProducIncart() {
    let gift = JSON.parse(localStorage.getItem('gift'));
    let productInCart = getProductInCart();
    let productKey = [];

    for (const product of productInCart) {
      productKey.push(product.id);
    }

    for (let i = 0; i < gift.length; i++) {
      if (productKey.includes(gift[i].giftKey)) {
        continue;
      }

      for (const product of gift[i].product) {
        product.quantity = '';
      }

      gift[i].attribute.selected = '';
    }

    localStorage.setItem('gift', JSON.stringify(gift));
  }

  // Delete gift wrap if empty
  function checkGiftEmpty() {
    let gift = JSON.parse(localStorage.getItem('gift'));

    for (let i = gift.length - 1; i >= 0; i--) {
      let giftEmpty = gift[i].product.every(product => product.quantity === '');

      if (giftEmpty && gift.length > 1) {
        gift.splice(i, 1);
      } else {
        break;
      }
    }

    localStorage.setItem('gift', JSON.stringify(gift));
  }

  // Initialize gift
  window.initGift = function initGift(giftOptionsDesignMode = '') {
    if (giftOptionsDesignMode != '') {
      giftOptions = giftOptionsDesignMode;
    }

    if (typeof giftOptions !== "undefined" && giftOptions.enable == 'true') {
      giftAttributeOptions = [{ value: '', content: '指定なし' }];
      let products = giftOptions.products;

      for (const product of products) {
        giftAttributeOptions.push({
          id: product.id,
          value: product.title,
          wrapping_tags: product.wrappingTags,
          content: product.title,
          dataOption: product.dataOption,
          blockAttribute: product.blockAttribute,
        });

        giftProductIdArray.push(product.id);
      }

      // Check that the gift version stored in local storage is the same as the current version.
      checkGiftVersion();
    }
  }

  // Add a new gift pack
  $(document).on('click', '#add-gift-box', function () {
    let error = false;
    let errorMessage = '<span class="error-message" style="color: red; font-size: 12px">必須</span>';
    let gifts = getGiftItems();

    for (const gift of gifts) {
      let giftEmpty = gift.product.every(product => product.quantity === '');
      let elGift = $(`.Cart__NoteContainer.cart__item-row[data-index="${gift.index}"]`);

      if (giftEmpty) {
        elGift.find('.gift-product-quantity').css('border-color', 'red');
        error = true;
      }

      if (gift.attribute.selected == '') {
        let elGiftBoxAttribute= elGift.find('.gift-box-attribute');
        if (elGiftBoxAttribute.next('.error-message').length == 0) {
          elGiftBoxAttribute.after(errorMessage);
        }
        error = true;
      }

      elGift.find('.gift-option').each(function () {
        if ($(this).val() == '') {
          if ($(this).next('.error-message').length == 0) {
            $(this).after(errorMessage);
            $(this).css('margin-bottom', '0');
          }

          error = true;
        }
      });
    }

    if (error){
      return false;
    }

    var gift_item = addNewGiftItem();
    $('.list-gift-box').append(buildGiftItemHtml(gift_item));

    if (getGiftItems().length < giftOptions.limit) {
      $('.button-gift-box').html(getHrHtml() + getGiftBoxButtonHtml());
    } else {
      $('.button-gift-box').html(getHrHtml());
    }
  });

  // Change gift wrapping
  $(document).on('change', '.gift-box-attribute', function () {
    var gift_items = getGiftItems();
    var productInGift = false;
    let currentSelectedId = $(this).find('option:selected').data('id');
    let index = $(this).parents('.Cart__NoteContainer.cart__item-row').data('index');
    let selectValue = $(this).val();

    for (let i in gift_items) {
      if (gift_items[i].index == index) {
        gift_items[i].attribute.selected = $(this).val();
        gift_items[i].attribute.selected_id = currentSelectedId;
        gift_items[i].gift_product = currentSelectedId;

        for (const gift of gift_items[i].attribute.value) {
          if (gift.id == currentSelectedId) {
            gift_items[i].wrapping_tags = gift.wrapping_tags;
          }
        }

        for (let j in gift_items[i].product) {
          if (gift_items[i].product[j].quantity !== '') {
            productInGift = true;
          }

          if ($(this).val() == '' || !gift_items[i].wrapping_tags.includes(gift_items[i].product[j].wrapping)) {
            gift_items[i].product[j].quantity = '';
          }
        }

        gift_items[i].attribute.giftOptionAtrribute = {};
      }
    }

    localStorage.setItem('gift', JSON.stringify(gift_items));

    if (productInGift || selectValue == '') {
      updateGiftProduct();
    }

    $('.list-gift-box').html(getHrHtml() + buildGiftHtml());
  });

  // Check if the number of products entered is valid or not. If invalid, set it to null
  $(document).on('keyup', '.gift-product-quantity', function () {
    checkInputVal($(this));
  });

  // Change the quantity of products in the gift
  $(document).on('change', '.gift-product-quantity', function () {
    let gift_items = getGiftItems();
    let inputVal = checkInputVal($(this));

    if (inputVal == 'false') {
      return false;
    }

    if (inputVal == 0) {
      inputVal = '';
    }

    for (let i in gift_items) {
      let index = $(this).parents('.Cart__NoteContainer.cart__item-row').data('index');
      if (gift_items[i].index == index) {
        for (let j in gift_items[i].product) {
          if (gift_items[i].product[j].id == $(this).data('id')) {
            gift_items[i].product[j].quantity = inputVal;
            gift_items[i].product[j].disabled = 0;
          }
          if (gift_items[i].product[j].quantity == '') {
            gift_items[i].product[j].disabled = 1;
          }
        }
      }
    }
    localStorage.setItem('gift', JSON.stringify(gift_items));
    updateGiftProduct();
    $('.list-gift-box').html(getHrHtml() + buildGiftHtml());
  });

  // Update the number of products in the gift pack when the number of products in the cart changes.
  $(document).on('click', '.js-qty__adjust.js-qty__adjust--minus', function () {
    changeMaxQuantityGiftProduct($(this));
  });

  // Update the number of products in the gift pack when the number of products in the cart changes.
  $(document).on('click', '.js-qty__adjust.js-qty__adjust--plus', function () {
    changeMaxQuantityGiftProduct($(this));
  });

  // Update the number of products in the gift pack when the number of products in the cart changes.
  $(document).on('change', '.js-qty__num', function () {
    var productInCart = getProductInCart();

    changeMaxQuantityGiftProduct($(this));

    if (productInCart && productInCart.length == 0) {
      removeGiftProduct();
    }
    $('.list-gift-box').html(getHrHtml() + buildGiftHtml());
  });

  $('body').on('change', '.gift-option', function () {
    let gift_items = getGiftItems();
    let index = $(this).parents('.Cart__NoteContainer.cart__item-row').data('index');

    if ($(this).val() != '' && $(this).next('.error-message').length == 1) {
      $(this).next('.error-message').remove();
    }

    for (let i in gift_items) {
      if (gift_items[i].index == index) {
        gift_items[i].attribute.giftOptionAtrribute[$(this).attr('name')] = $(this).val();
      }
    }

    localStorage.setItem('gift', JSON.stringify(gift_items));
    updateGiftProduct();
  });

  // Check if the noshi option is selected or not
  $('body').on('click', '.cart__checkout', function (e) {
    let optionNotSelected = false;

    $('.gift-option').each(function () {
      if ($(this).attr('data-gift-empty') == 'false' && $(this).val() == '') {
        if ($(this).next('.error-message').length == 0) {
          $(this).after('<span class="error-message" style="color: red; font-size: 12px">必須</span>');
        }
        optionNotSelected = true;
      }
    });

    if (optionNotSelected) {
      e.preventDefault();
      $('html, body').animate({
        scrollTop: eval($(".list-gift-box .error-message").offset().top - 150)
      }, 500);
    }
  });

  /* All the above code will be initialized and run starting from here */
  window.initGift();
});